import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function AuthImage({ path, alt = "", className = "" }) {
  const [src, setSrc] = useState(null);

  useEffect(() => {
    let url;
    let alive = true;
    api.get(`/files/${path}`, { responseType: "blob" })
      .then(r => { url = URL.createObjectURL(r.data); if (alive) setSrc(url); })
      .catch(() => {});
    return () => { alive = false; if (url) URL.revokeObjectURL(url); };
  }, [path]);

  if (!src) return <div className={`${className} bg-[#F2EEE7] animate-pulse`} />;
  return <img src={src} alt={alt} className={className} />;
}
